/* MarieOdile productcarrousel.
   De viewport is een horizontale scrollcontainer: swipen op touch en scrollen
   met een trackpad werken native, slepen met de muis komt hieronder. De pijlen
   en teller zijn optioneel en lezen de scrollpositie terug.
   Sectie-gescoped, idempotent, en bestand tegen Theme Editor section reloads.
   Meerdere instanties op één pagina werken onafhankelijk. */
(function () {
  'use strict';

  function initShelf(shelf) {
    if (!shelf || shelf.dataset.moInit === '1') return;
    shelf.dataset.moInit = '1';

    var viewport = shelf.querySelector('[data-mo-viewport]');
    var cards = shelf.querySelectorAll('[data-mo-card]');
    var prev = shelf.querySelector('[data-mo-prev]');
    var next = shelf.querySelector('[data-mo-next]');
    var counter = shelf.querySelector('[data-mo-current]');
    if (!viewport || !cards.length) return;

    function step() {
      if (cards.length < 2) return cards[0].getBoundingClientRect().width;
      return cards[1].offsetLeft - cards[0].offsetLeft;
    }
    function maxScroll() { return viewport.scrollWidth - viewport.clientWidth; }

    function sync() {
      var s = step();
      var i = s ? Math.round(viewport.scrollLeft / s) : 0;
      if (counter) counter.textContent = Math.min(i + 1, cards.length);
      if (prev) prev.disabled = viewport.scrollLeft <= 2;
      if (next) next.disabled = viewport.scrollLeft >= maxScroll() - 2;
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; sync(); });
    }
    viewport.addEventListener('scroll', onScroll, { passive: true });

    function onPrev() { viewport.scrollBy({ left: -step(), behavior: 'smooth' }); }
    function onNext() { viewport.scrollBy({ left: step(), behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);

    /* Slepen met de muis. Touch en pen laten we aan de browser over. Na een
       sleepbeweging wordt de klik op de kaart geblokkeerd, anders opent elke
       sleep per ongeluk een product. */
    var down = false, moved = false, startX = 0, startLeft = 0;

    function onDown(e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true;
      moved = false;
      startX = e.clientX;
      startLeft = viewport.scrollLeft;
    }
    function onMove(e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) {
        moved = true;
        viewport.classList.add('is-dragging');
      }
      if (moved) viewport.scrollLeft = startLeft - dx;
    }
    function onUp() {
      if (!down) return;
      down = false;
      if (!moved) return;
      viewport.classList.remove('is-dragging');
      var s = step();
      if (s) viewport.scrollTo({ left: Math.round(viewport.scrollLeft / s) * s, behavior: 'smooth' });
    }
    function onClick(e) {
      if (!moved) return;
      e.preventDefault();
      e.stopPropagation();
      moved = false;
    }
    function onDragStart(e) { e.preventDefault(); }

    viewport.addEventListener('pointerdown', onDown);
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    viewport.addEventListener('click', onClick, true);
    viewport.addEventListener('dragstart', onDragStart);

    var t;
    function onResize() { clearTimeout(t); t = setTimeout(sync, 150); }
    window.addEventListener('resize', onResize);

    /* opruimen zodat een section reload geen dubbele listeners achterlaat */
    shelf.moDestroy = function () {
      viewport.removeEventListener('scroll', onScroll);
      if (prev) prev.removeEventListener('click', onPrev);
      if (next) next.removeEventListener('click', onNext);
      viewport.removeEventListener('pointerdown', onDown);
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
      viewport.removeEventListener('click', onClick, true);
      viewport.removeEventListener('dragstart', onDragStart);
      window.removeEventListener('resize', onResize);
      shelf.dataset.moInit = '';
    };

    sync();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-mo-shelf]').forEach(initShelf);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme Editor lifecycle */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-mo-shelf]').forEach(function (s) {
      if (typeof s.moDestroy === 'function') s.moDestroy();
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest('[data-mo-card]');
    var shelf = e.target.closest('[data-mo-shelf]');
    if (!card || !shelf) return;
    var viewport = shelf.querySelector('[data-mo-viewport]');
    var first = shelf.querySelector('[data-mo-card]');
    if (!viewport || !first) return;
    /* scroll het geselecteerde blok in beeld */
    viewport.scrollTo({ left: card.offsetLeft - first.offsetLeft, behavior: 'smooth' });
  });
})();
